import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';

// Lazy load this component as it's not commonly used
const APITestProofPage = lazy(() =>
  import('./APITestProofPage').then((m) => ({ default: m.APITestProofPage })),
);

export const Route = createFileRoute('/_protected/_consumer/api-test-proof/')({
  component: APITestProofPage,
});
